import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { Table } from 'reactstrap';
import common from 'constants/common';

const PatientPriorAuthorizations = ({ priorAuthorizations }) => (
  <div className="table-container">
    <h5>Prior Authorization</h5>
    <Table borderless border="0" cellSpacing="0" cellPadding="0">
      <thead>
        <tr>
          <th>Authorization Number</th>
          <th>Date Range</th>
        </tr>
      </thead>
      <tbody>
        {priorAuthorizations.map((priorAuthorization) => (
          <tr key={priorAuthorization.guid}>
            <td>{priorAuthorization.authorizationNumber || '123456789'}</td>
            <td>
              {format(
                new Date(priorAuthorization.startDate),
                common.dateFormats.priorAuthorization,
              )}{' '}
              to{' '}
              {format(
                new Date(priorAuthorization.endDate),
                common.dateFormats.priorAuthorization,
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

PatientPriorAuthorizations.propTypes = {
  priorAuthorizations: PropTypes.arrayOf(PropTypes.shape()),
};

export default PatientPriorAuthorizations;
